<template>
  <div class="container">
    <div class="face-box">
          <video id="_videoFace" width="375" height="200" preload autoPlay loop muted />
          <canvas id="_canvasFace" class="face-canvas" width="375" height="200" />
    </div>
    <div style='none'>
        <p>实时截图</p>
      <canvas id="_canvas2Face" width="375" height="200" />
    </div>
  </div>
</template>
<script>
const tracking = window.tracking;
let video,canvas,canvas2,context,context2
export default {
  data() {
    return {
      canvas: '',
      canvas2: '',
      context: '',
      context2: '',
      timer:true
    }
  },
  mounted() {
    this.initFace()
  },
  methods: {
    initFace() {
      video = document.getElementById('_videoFace');
      canvas = document.getElementById('_canvasFace');
      canvas2 = document.getElementById('_canvas2Face');
      context = canvas.getContext('2d');
      context2 =  canvas2.getContext('2d');
      const tracker = new tracking.ObjectTracker('face');
      tracker.setInitialScale(4);
      tracker.setStepSize(1);
      tracker.setEdgesDensity(0.1);
      tracking.track('#_videoFace', tracker, { camera: true });
      tracker.on('track', (event) => {
        // no-face
        if (event.data.length === 0) return;
        // debounce
        if (this.timer) {
          this.draw(event)
          this.timer = false;
          setTimeout(() => {
            this.timer = true;
          }, 0)
        }
      });
    },
    draw(event) {
      context.clearRect(0, 0, canvas.width, canvas.height);
      event.data.forEach((rect) => {
        context.strokeStyle = '#10ff87';
        context.strokeRect(rect.x, rect.y, rect.width, rect.height);
        context.font = '11px Helvetica';
        context.fillStyle = "#fff";
        context.fillText("x:" + rect.x + 'px', rect.x + rect.width + 5, rect.y + 11);
        context.fillText('y: ' + rect.y + 'px', rect.x + rect.width + 5, rect.y + 22);
      });
      context2.drawImage(video, 0, 0, 200, 150);
      const snapData = canvas2.toDataURL('image/png');
      const imgSrc = "data:image/png;" + snapData;
      this.$emit('change',imgSrc)
    }
  },
}
</script>
<style scoped>
.face-box{
    position: relative;
    display: inline-block;
}
.face-canvas{
    position: absolute;
    left: 0;
    top:0
}
</style>